import request, { METHODS } from "src/utils/api-base";

const productApis = {
  createProduct: (payload: { page: number; limit: number }) => {
    return request({
      route: "/app/products/create",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },
  getProductList: (params: {
    page?: number;
    limit: number;
    status?: "active" | "inactive";
    search?: string;
    categoryId?: string;
    brandId?: string;
    unitId?: string;
  }) => {
    return request({
      route: "/app/products/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  // Get single product by id
  getProduct: (_id: string) => {
    return request({
      route: `/app/products/${_id}`,
      method: METHODS.GET,
      auth: true,
    });
  },

  // Look up a product (or one of its variants) by exact barcode match
  lookupByBarcode: (barcode: string) => {
    return request({
      route: "/app/products/lookup/barcode",
      method: METHODS.GET,
      params: { barcode },
      auth: true,
    });
  },

  // Edit product
  editProduct: (payload: any) => {
    return request({
      route: `/app/products/${payload._id}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  // Delete product
  deleteProduct: (_id: string) => {
    return request({
      route: `/app/products/${_id}`,
      method: METHODS.DELETE,
      auth: true,
    });
  },

  // Bulk-create products from parsed spreadsheet rows
  bulkImport: (rows: Array<Record<string, any>>) => {
    return request({
      route: "/app/products/bulk-import",
      method: METHODS.POST,
      payload: { rows },
      auth: true,
    });
  },
};

export default productApis;
